<span class="overall">{{ abilities | playerScore: position: overall }}</span>
<div
  *ngIf="abilities | playerScore: position: overall | playerClass as playerClass"
  class="class-value"
  [ngClass]="'class-value--' + playerClass"
>
  {{ playerClass }}
</div>
